const options = [
  {
    title: 'Primary Care',
    description: [
      'We are a family practice that offers a wide variety of care options and services for you and your family. ',
    ],
  },
  {
    title: 'IV Hydration Therapy',
    description: [
      'A superior delivery system for vitamins, minerals, and amino acids essential for your immunity and health. ',
    ],
  },
  {
    title: 'Hormone Replacement Therapy',
    description: [
      'Overcome Your Hormone Inbalance with a treatment that replaces hormones that are at lower levels in the body.',
    ],
  },
  {
    title: 'Weight Loss',
    description: [
      'Reduce the number of calories consumed and increase the number of calories burned in order to create a calorie deficit, which can lead to weight loss.',
    ],
  },
  {
    title: 'Men’s Health',
    description: [
      'At Health Vitalized, we will treat your symptoms and improve your quality of life.',
    ],
  },
  {
    title: 'Aesthetics',
    description: [
      'Transform your look with our curated selection of aesthetic procedures.',
      'Explore the possibilities and unlock your true potential with our expert guidance and care.',
    ],
  },
];

export default options;
